import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Settings2 } from "lucide-react";
import { useTrawlStore } from "@/stores/trawl-store";

export function TrawlOptionsPopover() {
  const { options, setOptions, isTrawling } = useTrawlStore();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" disabled={isTrawling}>
          <Settings2 className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 space-y-4">
        <p className="text-sm font-medium">Trawl Options</p>

        <div className="space-y-2">
          <Label htmlFor="maxResults" className="text-xs">
            Max results per paper
          </Label>
          <Input
            id="maxResults"
            type="number"
            value={options.maxResults}
            onChange={(e) =>
              setOptions({ maxResults: Number(e.target.value) || 100 })
            }
            min={10}
            max={1000}
            className="h-8"
          />
        </div>

        <div className="space-y-2">
          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={options.includeReferences}
              onChange={(e) =>
                setOptions({ includeReferences: e.target.checked })
              }
              className="rounded"
            />
            Include references
          </label>
          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={options.includeRecommendations}
              onChange={(e) =>
                setOptions({ includeRecommendations: e.target.checked })
              }
              className="rounded"
            />
            Include recommendations
          </label>
        </div>
      </PopoverContent>
    </Popover>
  );
}
